import { Card } from './Card.styles';

import type { CardProps } from './Card.d';

const CardBase = ({
  border,
  children,
  footer,
  footerShrink,
  header,
  radius = 'rounded',
  shadow,
  spacing = 'medium',
  ...props
}: CardProps) => (
  <Card.Component
    data-border={border}
    data-radius={radius}
    data-shadow={shadow}
    data-testid="card"
    {...props}
  >
    {header && <Card.Header data-radius={radius}>{header}</Card.Header>}

    <Card.Content data-spacing={spacing}>{children}</Card.Content>

    {footer && (
      <Card.Footer data-radius={radius} data-spacing={!footerShrink && spacing}>
        {footer}
      </Card.Footer>
    )}
  </Card.Component>
);

export default CardBase;
